/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ToggleActivationOrderStakeholderCommand } from '../../models/toggle-activation-order-stakeholder-command';
import { ToggleActivationOrderStakeholderCommandResult } from '../../models/toggle-activation-order-stakeholder-command-result';

export interface ApiNurseryManagerOrderStakeholderDeleteOrderStakeholderDelete$Plain$Params {
      body?: ToggleActivationOrderStakeholderCommand
}

export function apiNurseryManagerOrderStakeholderDeleteOrderStakeholderDelete$Plain(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerOrderStakeholderDeleteOrderStakeholderDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ToggleActivationOrderStakeholderCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerOrderStakeholderDeleteOrderStakeholderDelete$Plain.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ToggleActivationOrderStakeholderCommandResult>;
    })
  );
}

apiNurseryManagerOrderStakeholderDeleteOrderStakeholderDelete$Plain.PATH = '/api/NurseryManager/OrderStakeholder/DeleteOrderStakeholder';
